<template>
    <v-container>
        <v-row>
            <v-col cols="6">
                <v-card flat>
                    <v-card-title>
                        <v-icon>mdi-calendar-clock</v-icon>
                        <span>Besøk hjemme-typer</span>
                    </v-card-title>
                    <v-card-text class="text--primary">
                        <p>Se oversikt og rediger typene i Besøk hjemme.</p>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn to="/hjemme/administrer/type" outlined>Rediger</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'GriefSettings',
};
</script>
